<div
  avoidMulticlick
  class="item-box"
  theming
  themingGroup="portal"
  [themingAsset]="type() === 'coin' ? 'shop-coin-box' : 'shop-gem-box'"
  (safeClick)="createPurchase()">
  <div class="item-box__tags">
    @if (multiplierPrize()) {
      <div
        data-testId="slotcom-shop-multiplier-tag"
        theming
        themingGroup="multiplierprize"
        themingAsset="multiplier"
        class="e-eventTag"></div>
    }

    @if (magicbag()) {
      <div
        data-testId="slotcom-shop-magicbag-tag"
        theming
        themingGroup="magicbag"
        themingAsset="shop-tag"
        class="e-eventTag"></div>
    }
  </div>

  <div
    id="shop-item-tag"
    class="tag tag-{{ item.tag }}"
    theming
    themingGroup="portal"
    [themingAsset]="'shop-' + tag"></div>

  <div class="info-container">
    <div class="icon-container">
      <div
        class="item-icon Rate{{ index }}-{{ type() }}"
        theming
        themingGroup="portal"
        [themingAsset]="'shop-' + type() + 's-' + index"></div>
    </div>

    <div class="c-income">
      @if (multiplierPrize()) {
        <div
          data-testId="slotcom-shop-multiplier-old-price"
          class="old-price">
          {{ item.value | number: '1.0-0' : ('common.culture' | translate) }}
        </div>
      }

      <slotcom-display
        [ngClass]="multiplierPrize() ? 'c-income__display c-income__display--multiplier' : 'c-income__display'"
        data-testId="slotcom-shop-tariffPrize-text"
        [classes]="[
          'c-display--shop',
          type() === 'gem' ? 'c-display--shop--gems' : '',
          multiplierPrize() ? 'c-display--shop--multiplier' : ''
        ]">
        <div
          displayIcon
          displayIconPos="insideLeft"
          class="c-display--{{ type() }}"></div>
        {{
          (multiplierPrize() ? item.value * multiplierPrize().properties.multiplierprize : item.value)
            | number: '1.0-0' : ('common.culture' | translate)
        }}
      </slotcom-display>
      <slotcom-button
        audioType="payment"
        data-testId="slotcom-shop-tariffPrize-button"
        class="c-button--shop {{ item.amount.length > 4 ? 'c-button--shop--large' : 'c-button--shop--short' }}">
        {{ item | formatShopPrice }}
      </slotcom-button>
    </div>
  </div>
</div>
